import React from 'react';
import Modal from '../../../components/modals';
import _ from 'lodash';
import { ReactComponent as CheckedIcon } from '../../../../assets/svg/checked-purple.svg';
import { ReactComponent as BellIcon } from '../../../../assets/svg/bell.svg';

class CopyShootCrew extends React.Component {
	constructor() {
		super();
		this.state = {
			selectedCrew: [],
		};
	}
	componentDidMount = () => {};
	handleCloseModal = () => {
		this.props.handleClose();
	};
	toggleAllSelected = () => {
		let selectedCrew = [];
		if (
			_.size(this.state.selectedCrew) ===
			_.size(this.props.copyDetails.eventDetails.crewDetails)
		) {
			selectedCrew = [];
		} else {
			selectedCrew = [...this.props.copyDetails.eventDetails.crewDetails];
		}

		this.setState({ selectedCrew });
	};

	handleToggleSelected = (crew) => {
		let selectedCrew = this.state.selectedCrew;

		let found = -1;
		found = _.findIndex(this.state.selectedCrew, {
			id: crew.id,
			role: crew.role,
			subRole: crew.subRole,
		});
		if (found === -1) {
			selectedCrew.push(crew);
		} else {
			selectedCrew.splice(found, 1);
		}
		this.setState({ selectedCrew });
	};
	render() {
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'center'}
			>
				<div className="notify-shoot-crew-modal">
					<div className="notify-header">
						<span className="inner-header">
							<span className="bell-icn">
								<BellIcon />
							</span>
							<span className="header-text">COPY CREW</span>
						</span>
					</div>
					<div className="outer-crew-container">
						<div className="crew-item">
							{_.size(this.state.selectedCrew) ===
							_.size(this.props.copyDetails.eventDetails.crewDetails) ? (
								<span
									className="check-box-icn"
									onClick={() => this.toggleAllSelected()}
								>
									<CheckedIcon />
								</span>
							) : (
								<span
									className="empty-check-box"
									onClick={() => this.toggleAllSelected()}
								></span>
							)}
							<span>ALL CREW</span>
						</div>
					</div>
					<div className="outer-crew-container">
						{_.map(this.props.copyDetails.eventDetails.crewDetails, (item, index) => {
							let isChecked = false;
							if (
								_.find(this.state.selectedCrew, {
									id: item.id,
									role: item.role,
									subRole: item.subRole,
								}) !== undefined
							) {
								isChecked = true;
							}
							return (
								<div className="crew-item">
									{isChecked ? (
										<span
											className="check-box-icn"
											onClick={() => this.handleToggleSelected(item)}
										>
											<CheckedIcon />
										</span>
									) : (
										<span
											className="empty-check-box"
											onClick={() => this.handleToggleSelected(item)}
										></span>
									)}
									<span className={isChecked ? '' : 'unselected-crew-text'}>
										{item.name} ({item.subRole[0] + item.role[0]})
									</span>
								</div>
							);
						})}
					</div>
					<div className="notify-crew-tail">
						<span className="cancel-btn" onClick={() => this.props.handleClose()}>
							Cancel
						</span>
						<span
							className="submit-btn"
							onClick={() => {
								if (_.size(this.state.selectedCrew) > 0) {
									/* let copyCrew = [];
									_.forEach(this.state.selectedCrew, (crew, index) => {
										let foundIndex = -1;
										foundIndex = _.findIndex(copyCrew, {
											userId: crew.id,
										});
										if (foundIndex !== -1) {
											copyCrew[foundIndex].roles.push({
												role: crew.role,
												subRole: crew.subRole,
											});
										} else {
											copyCrew.push({
												roles: [{ role: crew.role, subRole: crew.subRole }],
												userId: crew.id,
												isManager: crew.isManager,
											});
										}
									}); */
									this.props.copyCrew(this.state.selectedCrew);
									this.props.handleClose();
								}
							}}
						>
							Copy Selected Crew
						</span>
					</div>
				</div>
			</Modal>
		);
	}
}

export default CopyShootCrew;
